import {Client} from './client'

export = function (opts) {
  return new Client(opts);
}